
import { PointConceptCreate } from './PointConceptCreate';
import { PointConceptList } from './PointConceptList';
import { PointConceptShow } from './PointConceptShow';

export default {
    list: PointConceptList,
    show: PointConceptShow,
    create: PointConceptCreate
};
